module.exports = __webpack_public_path__ + "img/frame (173).47aeb983.jpg";